import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { HeaderWrapper } from '../../components/ModalResourceHeader.js';
import { ExpandedResourceTitle } from '../../components/ResourceTitle.js';
import { ExpandedResourceDropdownMenu } from '../../components/ExpandedResourceDropdownMenu.js';
import { ResourceVideoPlayer } from './ResourceVideoPlayer.js';

const ResourceContentVideo = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs(HeaderWrapper, {
        children: [
          /* @__PURE__ */ jsx(HeaderWrapper.Left, {
            children: /* @__PURE__ */ jsx(ExpandedResourceTitle, {})
          }),
          /* @__PURE__ */ jsx(HeaderWrapper.Right, {
            children: /* @__PURE__ */ jsx(ExpandedResourceDropdownMenu, {})
          })
        ]
      }),
      /* @__PURE__ */ jsx(ResourceVideoPlayer, {})
    ]
  });
};

export { ResourceContentVideo };
//# sourceMappingURL=ResourceContentVideo.js.map
